import { Component, ElementRef, Input, OnInit, OnDestroy, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { HaloCustomLoaderService,HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { AverageByDayModel, AverageByDayType, DataByType, EquipmentsAverageByDayChartModel, EquipmentsChartModelItem, ReportMapEntry, UtilizationFilter } from 'src/app/post-login/services/stats.model';
import { StatsService } from 'src/app/post-login/services/stats.service';
export var multi = [];
@Component({
  selector: 'app-average-by-time',
  templateUrl: './average-by-time.component.html',
  styleUrls: ['./average-by-time.component.scss']
})
export class AverageByTimeComponent implements OnInit {
  multi: any[];
  tooltip1 = { data: {}, type: AverageByDayType.DISTANCE };
  tooltip2 = { data: {}, type: AverageByDayType.DISTANCE };
  view: any[] = [700, 300];
  colorSchemeArray: string[] = [];
  isAllDisabled = true;
  rowData: AverageByDayModel;
  isCardioSelecet: boolean | undefined = undefined;
  DataByType = DataByType;
  dataType: DataByType = DataByType.DISTANCE;

  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  yAxisLabel: string = this.commonUtil.translateText('AVERAGE.#').replace('#', this.commonUtil.translateText('DISTANCE'));
  timeline: boolean = true;
  isInsigniaExist = false;
  insigniaCount = '0';
  paramName = AverageByDayType.DISTANCE;
  private averageDistance = this.commonUtil.translateText('AVERAGE.#').replace('#', this.commonUtil.translateText('DISTANCE'));
  private averageWorkout = this.commonUtil.translateText('AVERAGE.#').replace('#', this.commonUtil.translateText('WORKOUTS'));
  private averageWeight = this.commonUtil.translateText('AVERAGE.#').replace('#', this.commonUtil.translateText('WEIGHTS'));
  private sub = new Subscription();
  public previousWidthOfResizedDiv: number = 0;
  colorScheme = {
    domain: this.colorSchemeArray
  };
  @Input() filterData: UtilizationFilter[];
  @Input() equipmentColorMap: any[];
  @Input() productMixData: any;
  @Input() dateFrom: Date;
  @Input() dateTo: Date;
  @Output() filterChanged = new EventEmitter<UtilizationFilter[]>();
  @ViewChild('resizedDiv') resizedDiv: ElementRef;
  rootScopeData: RootScopeDeclare;
  unitDistance: string | undefined = '';
  unitWeight: string | undefined = '';
  customLoaderIsLoading = false;//customLoaderIsLoading for customSpinner.
  customLoaderErrorMsg:string;
  customLoaderRedirectButtonLabel:string;
  customLoaderRedirectButtonUrl:string;
  constructor(
    private _subscriptionService: StatsService,
    private _facilityService: FacilityService,
    private commonUtil: CommonUtil,
    private rootScopeService: RootScopeService,
    private haloCustomLoaderService: HaloCustomLoaderService,

  ) {
    Object.assign(this, { multi });
    this.getRootScopeData();
  }

  ngOnInit() {
    const facilitySub = this._facilityService.selectedFacilitySource.subscribe(async (res) => {
      if (res.summary.facilityRights.stats !== 'false' && res.summary.userRights.stats !== 'H') {
        this.filterData = [];
        this.filterChanged.emit([]);
        this.isInsigniaExist = false;
        this.insigniaCount = '0';
        this.getData();
      }
    });
    this.getData();
    this.sub.add(facilitySub);
  }

  getRootScopeData(): void {
    const rootScopeSub = this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData
      this.unitDistance = this.rootScopeData.preferredUnit === 'I' ? 'Mi' : 'Km';
      this.unitWeight = this.rootScopeData.preferredUnit ===  'I' ? 'Lbs' : 'Kgs';
    });
    this.sub.add(rootScopeSub);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.productMixData && changes.productMixData.currentValue && changes.productMixData.currentValue !== changes.productMixData.previousValue) {
      this.insigniaCount = this.productMixData.productMix.find((val: any) => val.activityId === '10001') ? this.productMixData.productMix.find((val: any) => val.activityId === '10001').noOfEquips : '0';
      this.isInsigniaExist = this.productMixData.productMix.find((val: any) => val.activityId === '10001') ? true : false;
      if (this.rowData) {
        if (!(this.rowData && this.rowData.reportMap.entry.find((val: { key: string; }) => val.key === '10001') ? true : false) && this.isInsigniaExist && !this.customLoaderIsLoading) {
          this.rowData.reportMap.entry = this.rowData.reportMap.entry.filter(val => val.key !== '10001');
          let tmpData = this.loadDefaultInsigniaData();
          this.rowData.reportMap.entry.push(tmpData);
          let totalEquipmentCount = 0;
          this.rowData.reportMap.entry.forEach(val => {
            totalEquipmentCount += Number(val.value.equipmentCount);
          })
          this.rowData.totalEquipmentCount = totalEquipmentCount;
          this.updateFilterData(this.rowData);
          this.confiruChart(this.rowData);
          let ind = this.filterData.findIndex(x => (x.type === 10001));
          if (ind === -1) {
            this.filterData.push({ value: false, colour: '#CC99CC', type: 10001, count: Number(this.insigniaCount) });
            this.filterChanged.emit(this.filterData);
          }
        } else {
          for (let i = this.filterData.length - 1; i >= 0; i--) {
            let ind = this.filterData.findIndex(x => (x.type === 10001));
            if (ind != -1) {
              this.filterData.splice(ind, 1);
            }
          }
          this.filterChanged.emit(this.filterData);
        }
      }
    }

    if (changes.dateFrom && changes.dateFrom.currentValue && changes.dateFrom.previousValue && (changes.dateFrom.currentValue.getMonth() !== changes.dateFrom.previousValue.getMonth() || changes.dateFrom.currentValue.getDate() !== changes.dateFrom.previousValue.getDate())
      || changes.dateTo && changes.dateTo.currentValue && changes.dateTo.previousValue && (changes.dateTo.currentValue.getMonth() !== changes.dateTo.previousValue.getMonth() || changes.dateTo.currentValue.getDate() !== changes.dateTo.previousValue.getDate())) {
      this.dateFrom = changes.dateFrom.currentValue;
      this.dateTo = changes.dateTo.currentValue;
      this.getData();
    }
  }

  getData() {
    this.customLoaderIsLoading = true;
    const from = (this.dateFrom.getMonth() + 1) + '/' + this.dateFrom.getDate() + '/' + this.dateFrom.getFullYear();
    const to = (this.dateTo.getMonth() + 1) + '/' + this.dateTo.getDate() + '/' + this.dateTo.getFullYear();
    const averageByTimeSub = this._subscriptionService.getAverageByTime(this._facilityService.selectedFacilityId(), from, to, Intl.DateTimeFormat().resolvedOptions().timeZone).subscribe((data: AverageByDayModel) => {
      this.customLoaderIsLoading = false;
      this.updateFilterData(data);
      //mock weight data if not exist TODO: remove when it is fixed on backend
      if (!data.reportMap.entry[0].value.weightsData) {
        let len = data.reportMap.entry[0].value.distanceData.length;
        data.reportMap.entry.forEach(item => {
          item.value.weightsData = [];
          for (let i = 0; i < len; i++) {
            item.value.weightsData.push('0.0');
          }
        });
      }
      this.rowData = data;
      if (!(data.reportMap.entry.find((val: { key: string; }) => val.key === '10001') ? true : false) && this.isInsigniaExist) {
        let tmpData = this.loadDefaultInsigniaData();
        this.rowData.reportMap.entry.push(tmpData);
        this.rowData.totalEquipmentCount = Number(this.rowData.totalEquipmentCount);
      }
      this.getChartData();
      this.confiruChart(this.rowData);
    },err => {
      this.customLoaderErrorMsg = HaloCustomLoaderErrorType.APIFAILED;
    });
    this.sub.add(averageByTimeSub);
  }

  updateFilterData(data: AverageByDayModel) {
    this.filterData.forEach(item => {
      let i = data.reportMap.entry.findIndex(x => Number(x.key) === item.type);
      if(i === -1) {
        if(item.type === 10001 && !this.isInsigniaExist) {
          this.filterData.splice(i, 1);
        }
        if(item.type !== 10001 && item.type !== -1) {
          this.filterData.splice(i, 1);
        }
      }
    });
    this.filterChanged.emit(this.filterData);
  }

  loadDefaultInsigniaData(): ReportMapEntry {
    let data: ReportMapEntry = new ReportMapEntry();
    data.key = "10001";
    let usageLen = this.rowData.usageType.length;
    let disance = [];
    let hoursData = [];
    let workoutsData = [];
    let weightsData = [];

    for (let i = 0; i < usageLen; i++) {
      disance.push("0.0");
      hoursData.push("0.0");
      workoutsData.push("0.0");
      weightsData.push("0.0");
    }
    data.value = {
      distanceData: disance,
      equipmentCount: Number(this.insigniaCount),
      hoursData: hoursData,
      workoutsData: workoutsData,
      weightsData: weightsData,
      preferredUnit: undefined
    }
    return data;
  }


  switchData(type: number) {
    this.dataType = type;
    switch (type) {
      case DataByType.DISTANCE:
        this.yAxisLabel = this.averageDistance;
        break;
      case DataByType.WORKOUTS:
        this.yAxisLabel = this.averageWorkout;
        break;
      case DataByType.WEIGHTS:
        this.yAxisLabel = this.averageWeight;
        break;
    }
    this.getChartData();
  }


  confiruChart(data: AverageByDayModel) {
    var total = 0;
    if (this.filterData && this.filterData.length > 0) {
      this.colorScheme.domain = [];
      data.reportMap.entry.forEach(eq => {
        if ((this.filterData.find(x => x.type === Number(eq.key) && x.value === true) && eq.value.equipmentCount > 0) || this.filterData[0].value === true) {
          let c = this.equipmentColorMap.find(x => x.id == eq.key);
          this.colorScheme.domain.push(c && c.colour ? c.colour : '#ccc');
          total += Number(Number(eq.value.equipmentCount));
        }
        let filterItemIndex = this.filterData.findIndex(x => x.type === Number(eq.key));
        if (filterItemIndex == -1 && eq.value.equipmentCount > 0) {
          let c = this.equipmentColorMap.find(x => x.id == eq.key);
          this.colorScheme.domain.push(c && c.colour ? c.colour : '#ccc');
          this.filterData.push({ value: false, colour: c && c.colour ? c.colour : '#ccc', type: Number(eq.key), count: Number(eq.value.equipmentCount) });
        } else {
          this.filterData[filterItemIndex].count = Number(eq.value.equipmentCount);
        }
      });
    } else {
      this.colorScheme.domain = [];
      data.reportMap.entry.forEach(eq => {
        let c = this.equipmentColorMap.find(x => x.id == eq.key);
        this.colorScheme.domain.push(c && c.colour ? c.colour : '#ccc');
        this.filterData.push({ value: false, colour: c && c.colour ? c.colour : '#ccc', type: Number(eq.key), count: Number(eq.value.equipmentCount) });
        total += Number(Number(eq.value.equipmentCount));
      });
    }
    let insigniaIndex = this.filterData.findIndex(f => f.type === 10001);
    if(data.reportMap.entry.find(val => val.key === '10001') && this.isInsigniaExist && insigniaIndex == -1){
      let c = this.equipmentColorMap.find(x => x.id == '10001');
      this.filterData.push({ value: false, colour: c && c.colour ? c.colour : '#ccc', type: Number('10001'), count: Number(this.insigniaCount) });
    }    
    // move insignia data to the last in array
    if(insigniaIndex != -1 && insigniaIndex != this.filterData.length-1) {
      let tmp = this.filterData[insigniaIndex];
      this.filterData.splice(insigniaIndex, 1);
      this.filterData.push(tmp);
      this.colorScheme.domain = [...new Set(this.colorScheme.domain)];
    }
    // move insignia data to the last in array
    if(insigniaIndex != -1 && insigniaIndex != this.filterData.length-1) {
      let tmp = this.filterData[insigniaIndex];
      this.filterData.splice(insigniaIndex, 1);
      this.filterData.push(tmp);
      this.colorScheme.domain = [...new Set(this.colorScheme.domain)];
    }
    let all: number = this.filterData.findIndex(x => x.type === -1);
    let count = this.filterData.reduce((sum, current) => current.type != -1 ? sum + current.count : sum, 0);
    let val =  this.filterData.findIndex(x => x.value == true && x.type != -1) == -1;
    this.isAllDisabled = val;
    let newItem = { value: val, colour: '#ccc', type: -1, count: count }
    if (all == -1) {
      this.filterData = [newItem].concat(this.filterData);
    } else {
      this.filterData[all] = newItem;
    }
    this.filterChanged.emit(this.filterData);
    this.isCardio();
  }

  isCardio() {
    if(this.isInsigniaExist) {
      if(this.filterData[0].value) {
        this.isCardioSelecet = this.filterData.findIndex(x => (x.type !== 10001) && (x.type !== -1)) !== -1 ? undefined : false;
      } else if(this.filterData.find(x => x.type === 10001)?.value && this.filterData.findIndex(x => x.value && x.type !== 10001) === -1) {
        this.isCardioSelecet = false;
      } else if(!this.filterData.find(x => x.type === 10001)?.value && this.filterData.findIndex(x => x.value && x.type !== 10001) !== -1) {
        this.isCardioSelecet = true;
      } else {
        this.isCardioSelecet = undefined;
      }
    } else {
      this.isCardioSelecet = true;
    }
  }

  changeSelectAll(item: UtilizationFilter) {
    let i = this.filterData.findIndex(x => x.type == item.type);
    this.filterData[i].value = !this.filterData[i].value;
    if (i = 0 && this.filterData[i].value) {
      this.isAllDisabled = true;
      this.filterData.forEach(i => {
        i.type != -1 ? i.value = false : i.value;
      });
    } else {
      this.isAllDisabled = false;
    }
    if (item.type == -1) {
      this.filterData.forEach(i => {
        i.type != -1 ? i.value = false : i.value;
      });
    }


    if (this.filterData.find(x => x.value && x.type != -1) == undefined) {
      this.filterData[0].value = true;
      this.isAllDisabled = true;
      this.colorScheme.domain = [];
      this.filterData.forEach(item => {
        if (item.type != -1) {
          this.colorScheme.domain.push(item.colour);
          this.getChartData();
        }
      })
    } else {
      this.filterData[0].value = false;
      let tmp: any[] = [];
      this.colorScheme.domain = [];
      this.filterData.forEach(item => {
        if (item.value) {
          let tmpMulti = new EquipmentsAverageByDayChartModel(this.rowData, this.paramName).equipmentsUtilizationChartModel;
          tmp.push(tmpMulti.find((x: EquipmentsChartModelItem) => Number(x.name) == item.type));
          this.colorScheme.domain.push(item.colour);
        }
      });

      this.isAllDisabled = false;
      this.multi = tmp;
      this.formatNames(this.multi);
    }
    this.filterChanged.emit(this.filterData);
    this.isCardio();
  }

  formatNames(data: any) {
    if (data && data.length > 0) {
      data.forEach((item: EquipmentsChartModelItem) => {
        item.name = this.commonUtil.translateText('EQ.TYPE.' + item.name);
        item.series.forEach((s: { name: string; value: number }) => {
          s.name = Number(s.name) < 10 ? '0' + s.name + ':00' : s.name + ':00';
        });
      });
    }

  }

  getChartData() {
    switch (this.dataType) {
      case DataByType.DISTANCE:
        this.paramName = AverageByDayType.DISTANCE;
        this.tooltip1.type = AverageByDayType.WORKOUT;
        this.tooltip2.type = AverageByDayType.WEIGHT;
        break;
      case DataByType.WORKOUTS:
        this.paramName = AverageByDayType.WORKOUT;
        this.tooltip1.type = AverageByDayType.DISTANCE;
        this.tooltip2.type = AverageByDayType.WEIGHT;
        break;
      case DataByType.WEIGHTS:
        this.paramName = AverageByDayType.WEIGHT;
        this.tooltip1.type = AverageByDayType.DISTANCE;
        this.tooltip2.type = AverageByDayType.WORKOUT;
        break;
    }
    let tmpMulti = new EquipmentsAverageByDayChartModel(this.rowData, this.paramName).equipmentsUtilizationChartModel;
    if (this.filterData && this.filterData.length > 0 && !this.filterData[0].value) {
      for (let i = tmpMulti.length - 1; i >= 0; i--) {
        let ind = this.filterData.findIndex(x => (x.type === Number(tmpMulti[i].name)) && x.value);
        if (ind === -1) {
          tmpMulti.splice(i, 1);
        }
      }
    }

    this.multi = tmpMulti;
    this.tooltip1.data = new EquipmentsAverageByDayChartModel(
      this.rowData,
      this.tooltip1.type
    ).equipmentsUtilizationChartModel;
    this.tooltip2.data = new EquipmentsAverageByDayChartModel(
      this.rowData,
      this.tooltip2.type
    ).equipmentsUtilizationChartModel;
    this.formatNames(this.multi);
    this.formatNames(this.tooltip1.data);
    this.formatNames(this.tooltip2.data);
  }

  getValue(model: any, type: number) {
    let data: any;
    if (this.dataType == DataByType.DISTANCE) {
      data = type == 2 ? this.tooltip1 : this.tooltip2;
    } else if (this.dataType == DataByType.WORKOUTS) {
      data = type == 1 ? this.tooltip1 : this.tooltip2;
    } else {
      data = type == 1 ? this.tooltip1 : this.tooltip2;
    }
    let index = this.multi.findIndex(x => x.name == model.series);
    const value = data && data.data && data.data.length > 0 ? data.data.find((d: any) => d.name === model.series).series.find((x: { name: string, value: number }) => x.name == model.name)?.value : undefined;
    let unit  = this.multi[index].preferredUnit === undefined ? this.unitWeight : this.multi[index].preferredUnit === 'I' ? 'Lbs' : 'Kgs';
    return  type === 3 ? value + ' ' + unit : value;
  }

  ngAfterViewChecked() {
    if (this.resizedDiv != undefined) {
      if (this.previousWidthOfResizedDiv != this.resizedDiv.nativeElement.clientWidth) {
        this.multi = [...this.multi]
      }
      this.previousWidthOfResizedDiv = this.resizedDiv.nativeElement.clientWidth;
    }
  }

  count(model: any) {
    let index = this.multi.findIndex(x => x.name == model.series);
    return this.multi[index].count;
  }

  getFromSeries(model: any) {
    return [model[model.length - 1]];
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
